import { useEffect, useState } from "react";
import Modal from "../../../elements/Modal";
import Button from "../../../form/Button";
import { toast } from "react-toastify";
import { useSearchParams } from "react-router-dom";
import MultiFileUploader from "../../../common/MultiFileUploader";
import { fileAddEdit } from "../../../../services/mediaService";
import { mediaExtensions } from "../../../constant/constant";

const UploadFile = ({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
}) => {
  const [selectedFile, setSelectedFile] = useState([]);
  const [progress, setProgress] = useState(0);
  const [searchParams, setSearchParams] = useSearchParams();
  const folderData = searchParams.get("folderData");
  const [loading, setLoading] = useState(false);

  const handleFile = (newFileList) => {
    if (!newFileList || newFileList.length === 0) return;

    const allowedExtensions = Object.values(mediaExtensions).flat();

    const validFiles = [];

    for (const file of newFileList) {
      const fileExtension = "." + file.name.split(".").pop().toLowerCase();

      if (allowedExtensions.includes(fileExtension)) {
        validFiles.push(file);
      } else {
        toast.warning(`"${file.name}" is not an allowed file type.`);
      }
    }

    if (validFiles.length > 0) {
      setSelectedFile(validFiles); // ✅ set all valid files
      // sendFiles(validFiles);     // optionally send them
    }
  };

const onSubmit = async () => {
  if (!selectedFile || selectedFile.length === 0) {
    toast.error("Please select at least one file.");
    return;
  }

  setLoading(true);
  const payload = {
    media: selectedFile,
    ...(data?._id && { id: data?._id }),
    ...(folderData && folderData !== "root" && { key: folderData }),
  };

  try {
    const result = await fileAddEdit(payload, setProgress);
    if (result?.status === 200 || result?.status === 201) {
      toast.success(result.message || "File saved successfully");
      getResponse(result);
      close = () => {};
    } else {
      toast.error(result.message || "Failed to save file");
    }
  } catch (error) {
    toast.error(error.message || "Failed to save file");
  } finally {
    setSelectedFile([]);
    setLoading(false);
    setProgress(0);
  }
};

  return (
    <>
      <Modal
        isOpen={open}
        setIsOpen={() => {
          close();
        }}
        title={"Upload New File"}
        size="xl2"
        modaltitleClasses={"!text-slate-200 text-[15px]"}
        headerclassName={""}
        titleIcon={"titleIcon"}
        subtitle={"Upload files to organize your media."}
      >
        <div className="h-full overflow-y-auto p-3">
          <MultiFileUploader
            handleFile={(file) => handleFile(file)}
            progress={progress}
            selectedFile={selectedFile}
            mainclassName={"!h-62"}
          />
          <div className="flex justify-end pt-8">
            <Button
              buttonType="button"
              buttonClasses={"min-w-36"}
              buttonLabel={"Save"}
              {...(loading && {
                loading: true,
                buttonIconPosition: "left",
                isDisable: true,
              })}
              buttonFunction={() => onSubmit()}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};

export default UploadFile;
